import Vue from 'vue';

// @see https://github.com/vuejs/vue/issues/7701#issuecomment-368249629

function trimEmptyTextNodes(element) {
    for (let node of element.childNodes) {
        if (node.nodeType === node.TEXT_NODE && node.data.trim() === '') {
            node.remove();
        }
    }
}

Vue.directive('trim-whitespace', {
    inserted: trimEmptyTextNodes,
    componentUpdated: trimEmptyTextNodes,
});
